/**
 * Technical SEO Analyzer
 * Evaluates fields for OpenGraph, Canonical URLs, and slug properties.
 */

export const analyzeTechnical = (data) => {
  const { 
    slug = "", 
    canonicalUrl = "",
    ogTitle = "",
    ogDescription = "",
    ogImage = ""
  } = data;
  
  let score = 0;
  let maxScore = 10;
  const results = [];

  // 1. Slug length and formatting
  if (!slug) {
    results.push({ status: "error", text: "URL slug is missing." });
  } else {
    if (slug.length <= 60 && slug.length >= 10) {
      score += 2;
      results.push({ status: "success", text: "Slug length is optimal." });
    } else {
      results.push({ status: "warning", text: "Slug length should ideally be between 10-60 characters." });
    }

    if (!/[A-Z]/.test(slug) && !/\s/.test(slug)) {
      score += 2;
      results.push({ status: "success", text: "Slug is formatted correctly (lowercase, no spaces)." });
    } else {
      results.push({ status: "error", text: "Slug should be lowercase and use hyphens instead of spaces." });
    }
  }

  // 2. Canonical URL support
  if (canonicalUrl) {
    score += 2;
    results.push({ status: "success", text: "Canonical URL is set." });
  } else {
    // It's not strictly an error to omit it (self-referencing by default), but setting it explicitly is a good feature.
    results.push({ status: "warning", text: "Consider setting an explicit Canonical URL to prevent duplicate content." });
  }

  // 3. OpenGraph tags
  let ogCount = 0;
  if (ogTitle) ogCount++;
  if (ogDescription) ogCount++;
  if (ogImage) ogCount++;

  if (ogCount === 3) {
    score += 4;
    results.push({ status: "success", text: "All OpenGraph tags (title, desc, image) are provided." });
  } else if (ogCount > 0) {
    score += 2;
    results.push({ status: "warning", text: "Some OpenGraph tags are missing. Provide title, description, and image for best social sharing." });
  } else {
    results.push({ status: "warning", text: "No custom OpenGraph tags set (will fallback to default metadata)." });
  }

  return { score, maxScore, results };
};
